<template>
  <v-app-bar
    v-if="!$store.state.calculationFullscreen"
    app
    height="68"
    elevation="0"
    :style="$store.state.rail ? { 'padding-left': '36px' } : {}"
    id="navbar"
  >
    <v-sheet width="70%">
      <v-tabs color="#5353B5" height="48" v-model="$store.state.activeTab">
        <v-tab
          class="tab text-capitalize pa-0 rounded font-weight-bold"
          v-for="(tab, index) in $store.state.tabs"
          :key="index"
          :to="tab.to"
          :disabled="tab.disabled"
        >
          <div
            :class="`pa-2 rounded ${$store.state.activeTab === index ? 'text-primary active-tab' : 'text-grey-darken-1'}`"
          >
            {{ tab.text }}
          </div>
        </v-tab>
      </v-tabs>
    </v-sheet>

    <v-spacer />
    <v-sheet class="d-flex align-center">
      <v-menu :close-on-content-click="false" location="bottom" max-height="300px" v-model="notificationMenuState">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" class="mx-2" icon>
            <v-badge :model-value="notification_length" :content="notification_length" color="error">
              <img :src="require('@/assets/notification.svg')" width="24" />
            </v-badge>
          </v-btn>
        </template>

        <v-card class="rounded-lg">
          <v-card-item class="bg-primary-50" style="position: sticky; top: 0; z-index: 2" width="100%">
            <v-sheet class="bg-primary-50 d-flex justify-space-between align-center" width="100%">
              <div class="text-primary">
                <img :src="require('@/assets/info-circle-primary.svg')" class="me-1" />
                {{ $t('notifications') }}
              </div>
              <v-btn
                class="text-lowercase ms-2"
                variant="outlined"
                size="x-small"
                color="primary"
                @click="read_notif(null)"
                v-if="notification_length"
              >
                {{ $t('read_all') }}
              </v-btn>
              <v-btn
                class="text-lowercase ms-2"
                variant="outlined"
                size="x-small"
                color="natural"
                @click="clear_notif"
                v-else-if="!notification_length && notification.length"
              >
                {{ $t('clear') }}
              </v-btn>
            </v-sheet>
          </v-card-item>
          <v-progress-circular
            v-if="notificationLoading"
            indeterminate
            class="mx-auto w-100 my-2"
            color="primary"
          ></v-progress-circular>
          <v-sheet style="cursor: pointer" max-width="360">
            <v-card
              class="mx-2 my-4 pa-2 elevation-xl"
              v-for="notif in notification"
              :key="notif.id"
              :class="notif.unread ? 'text-primary' : ''"
            >
              <v-row>
                <v-col cols="9">
                  {{ notif.description }}
                </v-col>
                <v-spacer />
                <v-col cols="3" class="d-flex justify-end">
                  <v-btn
                    class="text-lowercase mt-1"
                    variant="outlined"
                    size="x-small"
                    @click="read_notif(notif)"
                    v-if="notif.unread"
                  >
                    {{ $t('read') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-sheet>
        </v-card>
      </v-menu>
      <v-menu :close-on-content-click="false">
        <template v-slot:activator="{ props }">
          <div>
            <v-btn v-bind="props" :icon="mobile" :height="mobile ? undefined : 60">
              <div class="d-md-none">
                <img
                  v-if="user_info.profile_image"
                  :src="user_info.profile_image"
                  width="36"
                  style="border-radius: 50%"
                  height="36"
                />
                <img v-else :src="require('@/assets/profile-circle.svg')" width="36" />
              </div>
              <div class="d-none d-md-flex align-center">
                <div>
                  <v-card-title class="pt-0">{{
                    user_info.fullname ? user_info.fullname : user_info.email?.split('@')[0]
                  }}</v-card-title>
                  <v-card-subtitle v-if="isAdmin" class="d-flex align-center">
                    <img :src="require('@/assets/wallet.svg')" class="me-2" />
                    {{ $t('credit') }}: {{ user_info.balance?.currancy_symbol }}{{ user_info.balance?.balance }}
                  </v-card-subtitle>
                </div>

                <div class="mx-2">
                  <img
                    v-if="user_info.profile_image"
                    :src="user_info.profile_image"
                    width="36"
                    style="border-radius: 50%"
                    height="36"
                  />
                  <img v-else :src="require('@/assets/profile-circle.svg')" width="36" />
                </div>

                <div class="me-2">
                  <img :src="require('@/assets/chevron-down-select.svg')" />
                </div>
              </div>
            </v-btn>
          </div>
        </template>
        <v-card class="py-2">
          <v-card-title>
            {{
              user_info.first_name ? user_info.first_name + ' ' + user_info.last_name : user_info.email?.split('@')[0]
            }}
          </v-card-title>
          <v-card-subtitle>
            {{ user_info.email }}
          </v-card-subtitle>

          <v-card-item v-if="isAdmin">
            <div class="d-flex mt-4">
              <img :src="require('@/assets/wallet.svg')" class="me-2" />
              {{ $t('credit') }}: {{ user_info.balance?.currancy_symbol }}{{ user_info.balance?.balance }}
            </div>
          </v-card-item>

          <v-card-actions class="d-flex justify-center" v-if="isAdmin">
            <v-btn
              color="primary"
              size="large"
              class="text-capitalize px-4"
              width="100%"
              variant="flat"
              @click="$store.state.chargeWallet = true"
            >
              {{ $t('charge_wallet') }}
            </v-btn>
          </v-card-actions>

          <v-card-actions class="d-lg-none">
            <v-select
              lable="language"
              :items="langs"
              density="compact"
              variant="outlined"
              hide-details
              :model-value="lang"
              @update:model-value="changeLang"
            ></v-select>
          </v-card-actions>

          <v-card-actions>
            <v-switch
              inset
              hide-details
              class="mx-1"
              color="primary"
              :label="$t('user_onboarding')"
              v-model="tour"
              @update:model-value="update_tour"
            ></v-switch>
          </v-card-actions>

          <v-card-actions class="flex flex-column">
            <v-btn class="text-capitalize w-100 d-flex justify-start" @click="profileSetting" elevation="0">
              <img :src="require('@/assets/setting2.svg')" class="me-2" />
              {{ $t('profile_settings') }}
            </v-btn>
            <v-btn @click="logout" class="text-capitalize w-100 d-flex justify-start" elevation="0">
              <img :src="require('@/assets/logout.svg')" class="me-2" />
              {{ $t('logout') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-sheet>
  </v-app-bar>
</template>

<script>
import api from '@/api'
import { defaultLocale, languages } from '@/locales'
import jwtDecode from 'jwt-decode'

export default {
  name: 'AppBar',
  props: {
    user_info: {
      type: Object,
      default: {},
    },
  },
  watch: {
    notificationMenuState(value) {
      // if clicked on notifs and it isn't loaded yet
      if (value && !this.notificationLoading && !this.notification.length) {
        this.notificationLoading = true
        api.notification().then((res) => {
          this.notificationLoading = false
          this.notification = res.data
          this.notification_length = this.notification.filter((item) => item.unread).length
        })
      }
    },
  },
  data: () => ({
    notification: [],
    notification_length: 0,
    lang: null,
    tour: false,
    user_info: {},
    notificationMenuState: false,
    notificationLoading: false,
  }),
  computed: {
    isAdmin() {
      return jwtDecode(localStorage.getItem('access')).user_info.is_admin
    },
    mobile() {
      return screen.width < 600
    },
    is_factory() {
      let user_info = jwtDecode(localStorage.getItem('access')).user_info
      return user_info.is_admin || user_info.is_verify_operator
    },
    langs() {
      return Object.keys(languages)
    },
  },
  created() {
    this.lang = localStorage.getItem('lang') || defaultLocale
    if (localStorage.getItem('tour') == 1 || localStorage.getItem('tour') == null) {
      this.tour = true
    } else {
      this.tour = false
    }
  },
  mounted() {
    var prevScrollpos = window.pageYOffset
    window.onscroll = function () {
      var currentScrollPos = window.pageYOffset
      try {
        if (prevScrollpos > currentScrollPos || currentScrollPos < 10) {
          document.getElementById('navbar').style.top = '0'
        } else if (currentScrollPos > 50) {
          document.getElementById('navbar').style.top = '-88px'
        }
      } catch {}
      prevScrollpos = currentScrollPos
    }
  },
  methods: {
    logout() {
      Object.keys(localStorage).forEach((key) => localStorage.removeItem(key))
      this.$router.go()
    },
    profileSetting() {
      this.$store.state.setting = 'profile'
      this.$store.state.editProfile = true
    },
    workspaceSetting() {
      this.$store.state.setting = 'workspace'
      this.$store.state.editProfile = true
    },
    read_notif(notif) {
      if (notif) {
        api
          .read_notification(notif.id)
          .then(() => {
            notif.unread = false
            this.notification_length = this.notification.filter((item) => item.unread).length
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        api
          .read_notification(null)
          .then(() => {
            this.notification.forEach((el) => {
              el.unread = false
              this.notification_length = this.notification.filter((item) => item.unread).length
            })
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    clear_notif() {
      this.notification
        .filter((item) => !item.unread)
        .forEach((el) => {
          api
            .clear_notification(el.id)
            .then(() => {
              this.notification = this.notification.filter((notif) => notif.id !== el.id)
            })
            .catch((err) => {
              console.log(err)
            })
        })
    },
    changeLang(event) {
      localStorage.setItem('lang', event)
      if (this.lang !== event) {
        this.$router.go()
      }
    },
    update_tour(event) {
      if (event) localStorage.setItem('tour', 1)
      else localStorage.setItem('tour', 0)
      this.$parent.$parent.$refs.tour.load_tour()
    },
  },
}
</script>

<style scoped>
.tab {
  min-width: auto;
  margin: 0 5px;
}
.active-tab {
  background: rgba(163, 163, 255, 0.16);
}
</style>
